import React from "react";
import { Text } from "@jsq/ds/core";
import { batchStatusToolTip } from "../styles_vanilla.css";
import { BatchStatusForUI } from "../util/batchStatusUtil";

export const BatchStatusToolTip = (params: { value: BatchStatusForUI }) => {
  return (
    <Text id="batch-status-tooltip" className={batchStatusToolTip}>
      {params.value === BatchStatusForUI.InProgress
        ? `Includes batches in "${BatchStatusForUI.Processing}", "${BatchStatusForUI.Funded}" & "${BatchStatusForUI.FundingInProgress}"`
        : params.value}
    </Text>
  );
};
